export const getCoWorkerProfileLanguage = () => {
  const language =
    window?.salja?.coworkerprofile?.data?.coworkerPreferences?.language;

  if (!language) {
    return undefined;
  }

  return {
    market: language.split("_")[1]?.toLowerCase(),
    language: language.split("_")[0]?.toLowerCase(),
  };
};
